<template>
  <van-pull-refresh v-model="refreshing" @refresh="loadAccountDetail">
    <div class="account-container">
      <div class="account-card">
        <header class="account-header">
          <h2>总资产</h2>
          <div class="price">¥{{ settleAccountTo.acctBalance }}</div>
        </header>
        <div class="account-info">
          <!-- <div>
            <p class="title">
              <span>冻结余额</span> <van-icon name="info-o" size="14px" @click="showTip(1)" />
            </p>
            <div>¥{{ settleAccountTo.frzBalance }}</div>
          </div> -->
          <div class="right">
            <p class="title">
              <span>可用余额</span><van-icon name="info-o" size="14px" @click="showTip(2)" />
            </p>
            <div>¥ {{ settleAccountTo.avlBalance }}</div>
          </div>
        </div>
      </div>

      <div class="bottom-cells">
        <template v-if="hasOpenPay">
          <van-cell title="提现" is-link to="/capital/withdrawal" size="large" />
          <van-cell title="提现记录" is-link to="/capital/record" size="large" />
          <van-cell title="收款账户" is-link to="/capital/account" size="large" />
          <van-cell title="礼物记录" is-link to="/capital/gift" size="large" />
        </template>
        <van-cell title="开通收款账户" v-else-if="!hasOpenPay && shopType == 0" @click="jump" />
        <van-cell title="开通收款账户" @click="jump" v-else-if="!hasOpenPay && shopType == 1" />
      </div>
    </div>
  </van-pull-refresh>
</template>

<script>
import { accountView } from '@/api/capital';
import { Toast, Dialog } from 'vant';
export default {
  data() {
    return {
      shopType: '', //0 个人  1企业
      status: '',
      hasOpenPay: false,
      refreshing: false,
      settleAccountTo: { frzBalance: '0.00', acctBalance: '0.0', avlBalance: '0.0' },
      adapayType:null
    };
  },
  created() {
    this.loadAccountDetail();
  },
  methods: {
    loadAccountDetail() {
      this.refreshing = true;
      accountView()
        .then(res => {
          // Toast('加载成功');
          this.shopType = res.data.shopType;
          this.status = res.data.status;
          this.adapayType = res.data.adapayType || null
          if (res.data.settleAccountTo && res.data.settleAccountTo.acctBalance !== undefined) {
            this.$store.commit('setHasOpenPay', true);
            this.hasOpenPay = true;
            this.settleAccountTo = res.data.settleAccountTo;
          }else if(res.data.hfpayAssetTo && res.data.hfpayAssetTo.acctBalance !== undefined){
            // this.$store.commit('setHasOpenPay', true);
            this.hasOpenPay = true;
            // this.settleAccountTo = res.data.hfpayAssetTo;
            // this.settleAccountTo.avlBalance = res.data.hfpayAssetTo.balance
          }
        })
        .finally(() => {
          this.refreshing = false;
        });
    },
    showTip(type) {
      const message = type === 1 ? '还未结算的余额及拍品保证金等' : '已结算完成的余额，可提现';
      Dialog({ message });
    },
    jump() {
      //    status 审核状态 0 审核中 1 审核通过 2 审核拒绝
      //  shopType 0个人开户 1企业开户
      //adapayType 企业商户下的  0个人开户 1企业开户
      if (this.shopType == 0) {
        this.$router.push('/capital/open');
      } else if (this.shopType == 1) {
        if (this.status == 0 || this.status == 2) {
        if(this.adapayType == 0){
          this.$router.push('/capital/open');
        }else if(this.adapayType == 1){
          this.$router.push('/capital/examine/' + this.status);
        }
        } else {
          Dialog.confirm({
              title: '',
              message: '请选择开户类型',
              confirmButtonText: '企业开户',
              cancelButtonText: '个人开户',
            })
              .then(() => {
                this.$router.push('/capital/enterprise/' + this.status);
              })
              .catch(() => {
                this.$router.push('/capital/open');
              });
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.account-container {
  padding: 12px;
  box-sizing: border-box;
}
.account-card {
  box-sizing: border-box;
  width: 100%;
  height: 183px;
  padding: 12px;
  overflow: hidden;
  background: url(https://img.zai-art.com/zaiart/saas/image/md/422ae4724ec7648cdab2bd5bd367e00a.png)
    no-repeat;
  background-size: 100% 183px;
  color: white;
  padding: 30px 30px 0 30px;
  .account-header {
    .price {
      font-size: 30px;
      font-weight: 500;
      font-family: DIN-Bold, DIN;
      font-weight: bold;
    }
    h2 {
      font-size: 14px;
      font-weight: 400;
    }
  }
  .account-info {
    box-sizing: border-box;
    display: flex;
    // justify-content: space-between;
    font-size: 14px;
    margin-top: 20px;
    .title {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      span {
        margin-right: 3px;
      }
    }
    .right {
      // margin-left: 100px;
    }
  }
}
.bottom-cells {
  width: 100%;
  box-sizing: border-box;
  padding-top: 12px;
  border-radius: 4px;
  overflow: hidden;
}
/deep/ .van-cell__title {
  color: #222222;
  font-weight: 500;
}
/deep/ .van-cell {
  padding: 15px 16px;
}
</style>
